module.exports = __webpack_public_path__ + "img/elementheights_jasa.c15ecc04.png";